import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'Maskhora'})
export class MaskhoraPipe implements PipeTransform{
    transform(value:string,mask:string){
        let pad = "000000";
        value = (pad + value).slice(-pad.length);
        let maskared:string = '';
        if (value) {
            let k = 0;
            for (let i = 0; i < mask.length; i++) {
                if (mask[i] == '#') {
                    if (value[k])
                        maskared += value[k++];
                }else {
                    maskared += mask[i];
                }
            }
        }
        return maskared;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/maskhora.pipe.ts